export default __webpack_public_path__ + "static/media/template.1f726864.txt";